import type { TaskStatus } from '@allemnii-pulse/shared';
import { Badge } from './Badge.js';

const STATUS_LABEL: Record<TaskStatus, string> = {
  backlog: 'Backlog',
  in_progress: 'In Progress',
  on_hold: 'On Hold',
  blocked: 'Blocked',
  testing: 'Testing',
  in_review: 'In Review',
  done: 'Done',
  canceled: 'Canceled',
};

const STATUS_VAR: Record<TaskStatus, string> = {
  backlog: '--st-backlog',
  in_progress: '--st-in-progress',
  on_hold: '--st-on-hold',
  blocked: '--st-blocked',
  testing: '--st-testing',
  in_review: '--st-in-review',
  done: '--st-done',
  canceled: '--st-canceled',
};

/** The one place a task status maps to a colour — see docs/PLAN.md §3/§4. */
export function StatusBadge({ status }: { status: TaskStatus }) {
  return (
    <Badge
      className="border-transparent"
      style={{
        color: `var(${STATUS_VAR[status]})`,
        backgroundColor: `color-mix(in srgb, var(${STATUS_VAR[status]}) 16%, transparent)`,
      }}
    >
      <span className="h-1.5 w-1.5 rounded-sm" style={{ backgroundColor: `var(${STATUS_VAR[status]})` }} />
      {STATUS_LABEL[status]}
    </Badge>
  );
}
